import 'core-js/stable';
import 'regenerator-runtime/runtime';
import { HeaderBar } from './components/HeaderBar/HeaderBar';
import { LocationPage } from './components/LocationPage/LocationPage';

/**
 * TWIG Variables
 * Variables set in template by twig, this should
 * the only place to declare these variables.
 */
declare const ajax_link: string;
declare const ajax_nonce: string;
declare const themeFolder: string;
// export template vars to rest of js.
export const ajaxLink = ajax_link;
export const ajaxNonce = ajax_nonce;
export const themeFolderPath = themeFolder;


/**
 * These components are loaded on every page
 * If you want large components to load on a single page
 * you should use the initModule
 */
new HeaderBar();
new LocationPage();

/**
 * @deprecated use registerReactComponents instead.
 * @see registerReactComponents
 *
 *  The modules below will only be initialized when the script finds
 *  the [data-module="<module-name>"] in the dom
 *
 *  @example
 *  <div data-module="-name-"></div>
 */

